<template>
  <div class="header">
    <v-app-bar class="header" color="#3c3c3c" dark fixed app :prominent="hasHero ? true : false"
      :shrink-on-scroll="hasHero ? true : false" :fade-img-on-scroll="hasHero ? true : false"
      :src="hasHero ? hero : ''">
      <v-btn icon v-if="$route.meta.back && $vuetify.breakpoint.mdAndDown" :to="{ name: $route.meta.back }"
        class="back-btn">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <template #img="{ props }" v-if="hasHero">
        <v-fade-transition>
          <v-img v-bind="props" gradient="to top right, #3C3C3C2d, #3C3C3C14" :style="{ 'margin-top': '20px' }"></v-img>
        </v-fade-transition>
      </template>

      <v-fade-transition>
        <v-toolbar-title v-html="title || $route.meta.title"
          v-if="title.length > 0 || $route.meta.title"></v-toolbar-title>
      </v-fade-transition>

      <v-spacer></v-spacer>

      <div class="profile-icon">
        <router-link
            :to="{ name: 'profile' }"
            v-if="loggedIn"
            class="d-flex align-center">
          <v-icon>person</v-icon>
        </router-link>
      </div>
      <v-app-bar-nav-icon @click="$store.commit('toggleDrawer', !drawer)"
        v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md"></v-app-bar-nav-icon>

      <template #extension v-if="hasTabs">
        <v-tabs background-color="#3c3c3c">
          <v-tab v-for="(tab, i) in tabs" :key="`tab-${i}`" :exact="true" :to="tab.link" v-html="tab.title" exact></v-tab>
        </v-tabs>

        <v-progress-linear color="accent" background-color="primary" :indeterminate="true" class="mt-0"
          v-if="hasTabs && loading"></v-progress-linear>
      </template>

      <v-progress-linear color="accent" background-color="primary" :indeterminate="true" class="mt-0"
        v-if="!hasTabs && loading"></v-progress-linear>
    </v-app-bar>
  </div>
</template>

<style lang="scss">
.header {
  .profile-icon {
    display: none;
  }

  @media screen and (max-width: 1263px) {
    .profile-icon {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .v-responsive {
    position: unset;
  }

  .back-btn.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active::before {
    opacity: 0;
  }

  .v-progress-linear {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .v-toolbar__extension {
    .v-tabs {
      margin-right: -16px;
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Appbar',
  computed: {
    hasHero() {
      return this.$route.meta.hero
    },
    hero() {
      return this.$route.meta.hero ? this.$store.getters.hero : false
    },
    hasTabs() {
      return this.$route.meta.tabs
    },
    ...mapGetters(['drawer', 'loading', 'tabs', 'title', 'loggedIn'])
  }
}
</script>
